import React, { useEffect } from "react";
import LoginNavbar from "./LoginNavbar";
import ForgotPage from "./ForgotPage";
import { useHistory } from "react-router-dom";

export default function Forgot() {
  const history = useHistory();

  useEffect(() => {
    const itemStr = localStorage.getItem("userData");
    if (itemStr) {
      history.push("/");
    }

    document.title = "VisaPro | Forgot Password";
  }, []);
  return (
    <div>
      <LoginNavbar />
      <ForgotPage />
    </div>
  );
}
